module.exports = __webpack_public_path__ + "img/20210314_120303.99d6bed1.jpg";